// eslint-disable-next-line no-useless-escape
export const validPasswordSymbolsPattern = /[^\w\d\s]{1,}/; // 1 or more lower letters anywhere in string
export const validPasswordLowerLettersPattern = '(.*[a-z]+.*){1,}'; // 1 or more lower letters anywhere in string
export const validPasswordUpperLettersPattern = '(.*[A-Z]+.*){1,}'; // 1 or more upper letters anywhere in string
export const validPasswordNumbersPattern = '(.*[0-9]+.*){1,}'; // 1 or more numbers anywhere in string
export const validPasswordMinLength = 8;
